<div style="font-family: sans-serif;">

  <!-- Title -->
  <div class="bg-[#faf8f5] py-8 sm:py-10 text-center border-b border-gray-200">
    <h1 class="text-2xl sm:text-3xl font-bold text-gray-900 tracking-wide" style="font-family: 'Roboto Slab', serif;">Find Your Art</h1>
    <div class="flex items-center justify-center gap-2 mt-3">
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
      <div class="w-8 h-[2px] bg-[#600b0b]"></div>
    </div>
  </div>

  <!-- Step 1 -->
  <div class="grid grid-cols-1 md:grid-cols-2 min-h-[300px] sm:min-h-[380px]">
    <!-- Image -->
    <div class="overflow-hidden">
      <img src="assets/images/step1.jpg" alt="Step 1 - Browse Categories" class="w-full h-full object-cover" />
    </div>
    <!-- Text -->
    <div class="bg-[#fdf5f0] flex items-center justify-center px-6 py-10 sm:py-14">
      <div class="text-center">
        <h2 class="text-xl sm:text-2xl font-bold text-gray-900" style="font-family: 'Roboto Slab', serif;">Step-1 :</h2>
        <div class="flex items-center justify-center gap-2 mt-2 mb-4">
          <div class="w-6 h-[2px] bg-[#600b0b]"></div>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
          <div class="w-6 h-[2px] bg-[#600b0b]"></div>
        </div>
        <p class="text-sm sm:text-[15px] text-[#600b0b]">
          Browse through <a routerLink="/listing" class="font-bold underline">different categories</a> to find the Art you love.
        </p>
      </div>
    </div>
  </div>

  <!-- Step 2 -->
  <div class="grid grid-cols-1 md:grid-cols-2 min-h-[300px] sm:min-h-[380px]">
    <!-- Text (left on desktop) -->
    <div class="bg-[#fdf5f0] flex items-center justify-center px-6 py-10 sm:py-14 order-2 md:order-1">
      <div class="text-center">
        <h2 class="text-xl sm:text-2xl font-bold text-gray-900" style="font-family: 'Roboto Slab', serif;">Step-2 :</h2>
        <div class="flex items-center justify-center gap-2 mt-2 mb-4">
          <div class="w-6 h-[2px] bg-[#600b0b]"></div>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
          <div class="w-6 h-[2px] bg-[#600b0b]"></div>
        </div>
        <p class="text-sm sm:text-[15px] text-[#600b0b]">
          Personalize your selected art with variety of customization, from Product type to Size to 200+ exclusive framing options.
        </p>
      </div>
    </div>
    <!-- Image (right on desktop) -->
    <div class="overflow-hidden order-1 md:order-2">
      <img src="assets/images/step2.jpg" alt="Step 2 - Customize" class="w-full h-full object-cover" />
    </div>
  </div>

  <!-- Step 3 -->
  <div class="grid grid-cols-1 md:grid-cols-2 min-h-[300px] sm:min-h-[380px]">
    <!-- Image -->
    <div class="overflow-hidden">
      <img src="assets/images/step3.jpg" alt="Step 3 - Decorate" class="w-full h-full object-cover" />
    </div>
    <!-- Text -->
    <div class="bg-[#fdf5f0] flex items-center justify-center px-6 py-10 sm:py-14">
      <div class="text-center">
        <h2 class="text-xl sm:text-2xl font-bold text-gray-900" style="font-family: 'Roboto Slab', serif;">Step-3 :</h2>
        <div class="flex items-center justify-center gap-2 mt-2 mb-4">
          <div class="w-6 h-[2px] bg-[#600b0b]"></div>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#600b0b" stroke-width="1.5"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>
          <div class="w-6 h-[2px] bg-[#600b0b]"></div>
        </div>
        <p class="text-sm sm:text-[15px] text-[#600b0b]">
          Decorate your walls.
        </p>
      </div>
    </div>
  </div>

</div>
